import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { InsuranceFlowService } from 'src/app/_services/insurance-flow.service';
import { InsuranceFlowStatus } from 'src/app/enums/insurance-flow/insurance-flow-status.enum';
import { ActionModalComponent } from 'src/app/shared/components/action-modal/action-modal.component';
import { IconsModule } from 'src/app/shared/icons/icons.module';

import { TaskDetailsService } from '../../../../task-details.service';
import { BaseStepperAction } from '../base-action';

@Component({
  selector: 'app-cancel-contract-action',
  standalone: true,
  imports: [CommonModule, NgbTooltipModule, IconsModule, ActionModalComponent],
  templateUrl: './cancel-contract.component.html',
})
export class CancelContractStepperActionComponent extends BaseStepperAction {
  @ViewChild('cancelContractModal') cancelContractModal: ActionModalComponent;

  submitted = false;

  get enabled(): boolean {
    const status = this.state?.insuranceFlowData?.status;
    return (
      status === InsuranceFlowStatus.PENDING_VALIDATION ||
      status === InsuranceFlowStatus.AWAITING_PAYMENT ||
      status === InsuranceFlowStatus.PENDING_CONTRACT
    );
  }

  constructor(
    taskDetailsService: TaskDetailsService,
    private readonly insuranceFlowService: InsuranceFlowService,
    private readonly toastrService: ToastrService
  ) {
    super(taskDetailsService);
  }

  cancelContract(): void {
    const flowId = this.state?.insuranceFlowData?.id;
    if (this.submitted || !flowId) {
      return;
    }

    this.submitted = true;
    this.insuranceFlowService
      .cancelContract({ flowId, byInsurer: false })
      .subscribe({
        next: (response) => {
          if (response.error) {
            this.showError();
          } else {
            this.toastrService.success($localize`Contrat annulé avec succès`);
            this.cancelContractModal?.closeModal();
            this.refreshTaskDetails();
          }
          this.submitted = false;
        },
        error: () => {
          this.showError();
          this.submitted = false;
        },
      });
  }

  private showError(): void {
    this.toastrService.error(
      $localize`Une erreur est survenue. Veuillez réessayer ultérieurement`
    );
  }
}
